import React from "react";

export const Alert = ({ children, className = "", ...props }) => {
  return (
    <div
      className={`relative w-full rounded-lg border p-4 ${className}`}
      role="alert"
      {...props}
    >
      {children}
    </div>
  );
};

export const AlertDescription = ({ children, className = "", ...props }) => {
  return (
    <div className={`text-sm ${className}`} {...props}>
      {children}
    </div>
  );
};
